angular.module('autoremind.reports.contacts', [])
    .directive('reportsPatientContactStatistics', ['$timeout', 'contactsReportService',
    function ($timeout, contactsReportService) {
        return {
            restrict: 'EA',
            templateUrl: 'app/reports/contacts/contacts.html',
            scope: false,
            link: function (scope, elem, attr) {
                console.log('contacts report');
                scope.statisticModel = contactsReportService.statisticsModel;
                scope.contactsReportService = contactsReportService;
                var statisticsChart = {};
                statisticsChart.type = "PieChart";
                statisticsChart.data = [['Label', 'Data']];
                statisticsChart.options = {
                    displayExactValues: false,
                    height: 220,
                    is3D: false,
                    chartArea: { left: 20, top: 20, bottom: 20, 'right': 20, height: "100%" },
                    colors: ['#3A80A4', '#4D9EC9', '#6EB3D4', '#93C4E2']
                };
                statisticsChart.formatters = {
                    number: [{
                            columnNum: 1,
                            pattern: " #,##0"
                        }]
                };
                scope.statisticsChart = statisticsChart;
                function updateChart() {
                    $timeout(function () {
                        console.log(scope.statisticModel);
                        scope.statisticsChart.data = [
                            ['Label', 'Data'],
                            ['Email or Phone', scope.statisticModel.active - scope.statisticModel.noAddress],
                            ['No contact data', scope.statisticModel.noAddress]
                        ];
                    });
                }
                scope.refreshStatistacs = function () {
                    contactsReportService.getStatistics()
                        .then(function () {
                        console.log(scope.statisticModel);
                        updateChart();
                    });
                };
                scope.refreshStatistacs();
            }
        };
    }]);
//# sourceMappingURL=contacts.directive.js.map